import { useMemo } from 'react';

let seedCounter = 1;

const useGenerateId = () => {
    const seed = useMemo(() => "uid-" + seedCounter++, []);
    return (suffix) => `${seed}-${suffix}`;
};

export default useGenerateId;